import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/tNUwkuWAd2acQyqjdygdXd/ChatGPT-Image-2-jul-2026_-08_17_03-p.m..webp';
const CHECKOUT_URL = 'https://nutritionist-pro.impultienda.ar/checkout';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-8 px-4 bg-white border-y-4 border-brand-gold/30 scroll-mt-4" data-id="element-129">
      <div className="max-w-2xl mx-auto" data-id="element-130">
        <div className="text-center mb-4" data-id="element-131">
          <p className="text-sm font-extrabold text-brand-gold uppercase tracking-widest mb-1" data-id="element-132">
            SPECIAL OFFER — COMPLETE 6-IN-1 SYSTEM
          </p>
          <p className="text-base font-bold text-brand-graphite/90 mb-3" data-id="element-133">
            Get instant access today and completely transform the way you manage
            your nutrition practice.
          </p>
          <div className="inline-block bg-brand-petrol text-white px-4 py-1.5 rounded-md shadow-md mb-4" data-id="element-134">
            <p className="font-bold text-base tracking-wide" data-id="element-135">
              🥗 NUTRITIONIST PRO™ — 6-in-1 System
            </p>
          </div>
          <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-136">
            <img src={PRODUCT_IMG} alt="Nutritionist Pro 6-in-1 System" className="w-full max-w-xs mx-auto object-contain drop-shadow-xl mb-4 hover:scale-[1.03] transition-transform duration-300" data-id="element-137" />
          </a>
        </div>

        <div className="bg-brand-cream border-4 border-brand-gold rounded-xl p-4 sm:p-6 text-center relative mb-4 shadow-2xl" data-id="element-138">
          <div className="mb-4" data-id="element-139">
            <p className="text-sm sm:text-base font-bold text-brand-graphite/70 mb-1" data-id="element-140">
              Regular Price: <span className="line-through" data-id="element-141">$97</span>
            </p>
            <p className="text-lg sm:text-xl font-extrabold text-red-600 mb-2 uppercase tracking-wide" data-id="element-142">
              🔥 72% OFF — LIMITED-TIME LAUNCH OFFER
            </p>
            <p className="text-5xl sm:text-6xl font-serif font-extrabold text-brand-graphite mb-1" data-id="element-143">
              $27 USD
            </p>
            <p className="text-xs sm:text-sm font-bold text-brand-graphite/60 uppercase tracking-wider" data-id="element-144">
              Pay securely in your local currency.
            </p>
          </div>

          <div className="bg-red-50 border-2 border-red-200 rounded-lg p-3 mb-5" data-id="element-145">
            <p className="text-sm font-bold text-red-600 mb-2 uppercase tracking-wide" data-id="element-146">
              🔥 Last Chance! This special price expires when the countdown
              reaches zero.
            </p>
            <div className="flex justify-center gap-3" data-id="element-147">
              <div className="text-center" data-id="element-148">
                <div className="bg-brand-graphite text-white text-xl sm:text-2xl font-bold px-3 py-1.5 rounded shadow-inner" data-id="element-149">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <p className="text-[10px] font-bold text-brand-graphite/70 mt-1 tracking-wider" data-id="element-150">
                  HOURS
                </p>
              </div>
              <div className="text-xl font-bold text-brand-graphite mt-1.5" data-id="element-151">
                :
              </div>
              <div className="text-center" data-id="element-152">
                <div className="bg-brand-graphite text-white text-xl sm:text-2xl font-bold px-3 py-1.5 rounded shadow-inner" data-id="element-153">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
                <p className="text-[10px] font-bold text-brand-graphite/70 mt-1 tracking-wider" data-id="element-154">
                  MINUTES
                </p>
              </div>
              <div className="text-xl font-bold text-brand-graphite mt-1.5" data-id="element-155">
                :
              </div>
              <div className="text-center" data-id="element-156">
                <div className="bg-brand-graphite text-white text-xl sm:text-2xl font-bold px-3 py-1.5 rounded shadow-inner" data-id="element-157">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
                <p className="text-[10px] font-bold text-brand-graphite/70 mt-1 tracking-wider" data-id="element-158">
                  SECONDS
                </p>
              </div>
            </div>
          </div>

          <CTAButton href={CHECKOUT_URL} className="!bg-brand-gold !text-brand-graphite border-none shadow-[0_4px_14px_0_rgba(200,168,107,0.39)] hover:shadow-[0_6px_20px_rgba(200,168,107,0.23)] hover:bg-brand-gold/90" data-id="element-159">
            🚀 YES! I WANT MY COMPLETE 6-IN-1 SYSTEM
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-1 text-sm text-brand-graphite font-bold" data-id="element-160">
          <div className="flex items-center gap-1" data-id="element-161">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-162" />
            <span data-id="element-163">4.9/5 — Verified Professional Reviews</span>
          </div>
          <span className="hidden sm:inline text-brand-gold" data-id="element-164">•</span>
          <div className="flex items-center gap-1" data-id="element-165">
            <Shield className="w-4 h-4 text-brand-petrol" data-id="element-166" />
            <span data-id="element-167">7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}